import { render, staticRenderFns } from "./MessageTrigger.vue?vue&type=template&id=2beed191"
import script from "./MessageTrigger.vue?vue&type=script&lang=js"
export * from "./MessageTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports